export const Languages = {
  KG: 'KG',
  RU: 'RU',
  kg: 'kg',
  ru: 'ru',
};

export const LanguagesMap = {
  KG: 'Кыргызча',
  RU: 'Русский',
  kg: 'Кыргызча',
  ru: 'Русский',
};

export const SubscriptionStatus = {
  FREE: 'Free',
  PRO: 'PRO',
};

export const mathsEvaluate = [1, 1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 12, 13, 15, 16, 17, 18, 19, 20, 21, 22, 23, 25, 26, 27, 28, 29, 30, 31, 32, 34, 35, 36, 37, 38, 39, 40, 41, 42, 44, 45, 46, 47, 48, 49, 50, 51, 52, 54, 55, 56, 57, 58, 59, 60, 61, 63, 64, 65, 66, 67];
export const analogiyaEvaluate = [5, 8, 10, 12, 13, 16, 17, 19, 21, 23, 25, 27, 29, 30, 33, 34, 36, 38, 40, 42, 44, 45, 48, 49, 51, 53, 55, 57, 59, 61, 63];
export const okuuTushunuuEvaluate = [5, 7, 8, 10, 12, 14, 16, 17, 20, 21, 23, 25, 26, 29, 30, 32, 34, 35, 38, 39, 41, 43, 44, 47, 48, 50, 52, 54, 56, 57, 58];
export const grammatikaEvaluate = [5, 6, 7, 8, 10, 12, 14, 16, 17, 19, 21, 23, 25, 26, 28, 30, 31, 34, 35, 37, 39, 40, 42, 44, 46, 48, 49, 51, 53, 55, 57];

export const SubjectNames = {
  mathBasic: 'mathBasic',
  mathAdvanced: 'mathAdvanced',
  analogy: 'analogiya',
  reading: 'okuuTushunuu',
  grammar: 'grammar',
};

export const SubjectIcons = {
  analogy: '/assets/svg/analogy.svg',
  reading: '/assets/svg/analogy.svg',
  mathBasic: '/assets/svg/math-basic.svg',
  mathAdvanced: '/assets/svg/math-advanced.svg',
  grammar: '/assets/svg/grammar.svg'
};

export const i18nLanguages = {
  kg: {
    lan: 'Кыр',
    flag: 'assets/img/kyrgyzstan-flag.jpg'
  },
  ru: {
    lan: 'Рус',
    flag: 'assets/img/russia-flag.jpg'
  }
};

export const LESSONS_LIST = [
  {
    titleRu: 'Математика',
    titleKg: 'Математика',
    icon: 'bx bx-shape-triangle',
    link: 'maths'
  },
  {
    titleRu: 'Физика',
    titleKg: 'Физика',
    icon: 'bx bx-shape-circle',
    link: 'physics'
  },
  {
    titleRu: 'Химия',
    titleKg: 'Химия',
    icon: 'bx bx-test-tube',
    link: 'chemistry'
  },
  {
    titleRu: 'Биология',
    titleKg: 'Биология',
    icon: 'bx bxl-trello',
    link: 'biology'
  },
  {
    titleRu: 'Английский язык',
    titleKg: 'Англис тили',
    icon: 'bx bx-font-family',
    link: 'english'
  },
  {
    titleRu: 'Русский язык',
    icon: 'bx bxs-book-bookmark',
    link: 'russian'
  },
  {
    titleRu: 'Кыргыз тили ',
    titleKg: 'Кыргыз тили ',
    icon: 'bx bxs-book-bookmark',
    link: 'russian'
  },
  {
    titleRu: 'История',
    titleKg: 'Тарых',
    icon: 'bx bx-history',
    link: 'history'
  }
];

export const OPTIONS_MAP = {
  'A': 0,
  'B': 1,
  'C': 2,
  'D': 3,
  'E': 4,
};

export const SCIENCE_LESSONS = ['MATHS', 'PHYSICS', 'CHEMISTRY'];
